import React from "react";
import Marty from "marty";
import { Link } from "react-router";
import Logo from "./Logo";
import ScrollMixin from "../../utils/mixins/onScroll";
import Hamburger from "../../utils/components/HamburgerButton";
import BuyButton from "./BuyButton";


let Header = React.createClass({
    mixins: [ScrollMixin],
    getInitialState() {
        return {
            collapse: false
        };
    },
    propTypes: {
        collapseDistance: React.PropTypes.number
    },
    calculateCollapseState(){
        if (!Marty.isServer) {
            return !!this.props.collapseDistance && window.pageYOffset >= this.props.collapseDistance;
        }
    },
    onScroll() {
        let newState = {
            collapse: this.calculateCollapseState()
        };

        if (!this.state.scrolled || this.state.collapse !== newState.collapse) {
            this.setState(newState);
        }
    },
    mailingList() {
        this.app.navActions.toggleMenu(true);
        this.app.navStore.showMailingListModal();
    },
    handleMenuClick(){
        this.app.navActions.toggleMenu();
    },
    closeMenu(){
        this.app.navActions.toggleMenu(true);
    },
    render() {
        return (
            <header
                className={["eo-header-wrap", (this.state.collapse ? "eo-header-collapse" : ""), (this.props.hidden ? "eo-header-closed" : "eo-header-open")].join(" ")}>
                <div className="eo-header">
                    <Link className="eo-link-nav float-left logo-link" to="/" onClick={this.closeMenu}><Logo
                        className="eo-logo"/></Link>
                    <BuyButton className="float-right"/>
                    <Hamburger handleClick={this.handleMenuClick} showClose={!this.props.hidden}/>
                    <nav className="eo-nav eo-responsive-nav" role="navigation">
                        {/*MOBILE NAV*/}
                        <Link className="eo-link-nav float-right eo-nav-item mobile" to="your-home" onClick={this.closeMenu}>Your home</Link>
                        <Link className="eo-link-nav float-right eo-nav-item mobile" to="features" onClick={this.closeMenu}>Features</Link>
                        <Link className="eo-link-nav float-right eo-nav-item mobile" to="technology" onClick={this.closeMenu}>Technology</Link>
                        <Link className="eo-link-nav float-right eo-nav-item mobile" to="support" onClick={this.closeMenu}>Support</Link>
                        {/*DESKTOP NAV*/}
                        <Link className="eo-link-nav float-right eo-nav-item desktop" to="support" onClick={this.closeMenu}>Support</Link>
                        <Link className="eo-link-nav float-right eo-nav-item desktop" to="technology" onClick={this.closeMenu}>Technology</Link>
                        <Link className="eo-link-nav float-right eo-nav-item desktop" to="features" onClick={this.closeMenu}>Features</Link>
                        <Link className="eo-link-nav float-right eo-nav-item desktop" to="your-home" onClick={this.closeMenu}>Your home</Link>
                    </nav>
                </div>
            </header>
        );
    }
});

export default Marty.createContainer(Header, {
    listenTo: ["navStore"],
    fetch: {
        hidden() {
            return this.app.navStore.menuHidden();
        }
    }
});



/** WEBPACK FOOTER **
 ** ./app/views/components/Header.js
 **/